import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { Spinner } from "react-bootstrap";

import {
	formatUploadHistoryCardDate,
	formatUploadRecordCount,
	getImportStatusClass,
} from "../utils/ehrUploadHistory";
import classes from "./EhrUploadHistoryDrawer.module.css";

const EhrUploadHistoryDrawer = ({
	historyRows,
	isLoading,
	onClose,
	onOpenImport,
	onPageChange,
	onRowsPerPageChange,
	pagination,
}) => {
	const statusClassFor = (status) => classes[getImportStatusClass(status)];

	return (
		<div className={classes.overlay} onClick={onClose} role="presentation">
			<aside
				aria-labelledby="upload-history-title"
				aria-modal="true"
				className={classes.drawer}
				onClick={(event) => event.stopPropagation()}
				role="dialog">
				<div className={classes.header}>
					<h2 className={classes.title} id="upload-history-title">
						Upload History
					</h2>
					<button aria-label="Close upload history" className={classes.closeButton} onClick={onClose} type="button">
						<X size={20} strokeWidth={2} />
					</button>
				</div>

				<div className={classes.body}>
					{isLoading ? (
						<div className={classes.stateBlock}>
							<Spinner animation="border" size="sm" style={{ color: "#064260" }} />
							<p>Loading upload history...</p>
						</div>
					) : historyRows.length === 0 ? (
						<div className={classes.stateBlock}>
							<p>No uploads found.</p>
						</div>
					) : (
						<ul className={classes.cardList}>
							{historyRows.map((row) => (
								<li className={classes.card} key={row.runId}>
									<div className={classes.cardTop}>
										<span className={classes.uploadId}>{row.displayId || "—"}</span>
										<span className={`${classes.statusBadge} ${statusClassFor(row.status)}`.trim()}>
											{row.status}
										</span>
									</div>

									<p className={classes.metaLine}>
										Uploaded: {formatUploadHistoryCardDate(row.uploadedAt)}
									</p>
									<p className={classes.metaLine}>Uploaded by: {row.uploadedByName || "—"}</p>

									<div className={classes.cardBottom}>
										<span className={classes.recordCount}>
											{formatUploadRecordCount(row.totalRows)} records
										</span>
										<button
											className={classes.viewDetailsButton}
											onClick={() => onOpenImport(row.runId)}
											type="button">
											View Details
											<ChevronRight aria-hidden="true" size={15} strokeWidth={2} />
										</button>
									</div>
								</li>
							))}
						</ul>
					)}
				</div>

				{!isLoading && pagination.totalPages > 1 ? (
					<div className={classes.footer}>
						<div className={classes.paginationMeta}>
							Page {pagination.page} of {pagination.totalPages}
						</div>
						<div className={classes.paginationControls}>
							<button
								aria-label="Previous page"
								className={classes.pageButton}
								disabled={pagination.page <= 1}
								onClick={() => onPageChange(pagination.page - 1)}
								type="button">
								<ChevronLeft size={16} strokeWidth={2} />
							</button>
							<button
								aria-label="Next page"
								className={classes.pageButton}
								disabled={pagination.page >= pagination.totalPages}
								onClick={() => onPageChange(pagination.page + 1)}
								type="button">
								<ChevronRight size={16} strokeWidth={2} />
							</button>
						</div>
					</div>
				) : null}
			</aside>
		</div>
	);
};

export default EhrUploadHistoryDrawer;
